import { client } from './claims';

export interface RedressStats {
  active_claims: {
    total: number;
    eligible: number;
    before_scheme: number;
    scheme_1: number;
    scheme_2: number;
    after_scheme: number;
    no_date: number;
  };
  cancelled_claims: {
    total: number;
    scheme_1: number;
    scheme_2: number;
    before_scheme: number;
    after_scheme: number;
    no_date: number;
  };
  grand_total: number;
  scheme_dates: {
    scheme_1: string;
    scheme_2: string;
  };
}

export const getRedressStats = () =>
  client.get<RedressStats>('/ui/admin/redress-stats', { timeout: 120000 }).then(res => res.data);
